module.exports = __webpack_public_path__ + "img/cover-slot-bg.90003c9e.jpg";